import { z } from 'zod'
import { AI_INPUT_FIELDS, AI_PARAMETER_TYPES } from '@/shared/model/ai-enums'
import { MODEL_PRESENTATION_BADGES, MODEL_PRESENTATION_POSITIONINGS, MODEL_PRESENTATION_STRENGTHS } from './model-presentation'

export const modelParameterRuleSchema = z.object({
  type: z.enum(AI_PARAMETER_TYPES).optional(),
  description: z.string(),
  enum: z.array(z.union([z.string(), z.number(), z.boolean()])),
  minimum: z.number().optional(),
  maximum: z.number().optional(),
  minLength: z.number().int().optional(),
  maxLength: z.number().int().optional(),
  minItems: z.number().int().optional(),
  maxItems: z.number().int().optional(),
})

export const modelCapabilityParametersSchema = z.object({
  required: z.array(z.enum(AI_INPUT_FIELDS)),
  properties: z.record(z.string(), modelParameterRuleSchema),
  additionalProperties: z.boolean(),
})

const capabilityParametersSchema = z.object({
  'text-to-image': modelCapabilityParametersSchema.optional(),
  'image-to-image': modelCapabilityParametersSchema.optional(),
  'text-to-video': modelCapabilityParametersSchema.optional(),
  'image-to-video': modelCapabilityParametersSchema.optional(),
  'video-generation': modelCapabilityParametersSchema.optional(),
  'digital-human': modelCapabilityParametersSchema.optional(),
})

const capabilityPresentationItemSchema = z.object({
  badge: z.enum(MODEL_PRESENTATION_BADGES).nullable(),
  positioning: z.enum(MODEL_PRESENTATION_POSITIONINGS).nullable(),
  strengths: z.array(z.enum(MODEL_PRESENTATION_STRENGTHS)),
  shortDescription: z.string().nullable(),
  sortOrder: z.number().int().nonnegative(),
})

const capabilityPresentationsSchema = z.object({
  'text-to-image': capabilityPresentationItemSchema.optional(),
  'image-to-image': capabilityPresentationItemSchema.optional(),
  'text-to-video': capabilityPresentationItemSchema.optional(),
  'image-to-video': capabilityPresentationItemSchema.optional(),
  'video-generation': capabilityPresentationItemSchema.optional(),
  'digital-human': capabilityPresentationItemSchema.optional(),
})

export const aiModelSchema = z.object({
  id: z.string(),
  name: z.string(),
  provider: z.string(),
  version: z.string(),
  description: z.string(),
  capabilities: z.array(z.enum(['text-to-image', 'image-to-image', 'text-to-video', 'image-to-video', 'video-generation', 'digital-human'])),
  mediaKind: z.enum(['image', 'video', 'avatar']),
  status: z.enum(['active', 'beta', 'maintenance']),
  recommended: z.boolean(),
  tags: z.array(z.string()),
  supportedRatios: z.array(z.string()),
  pricing: z.object({ credits: z.number(), unit: z.enum(['image', 'video', 'generation']) }),
  speedScore: z.number(),
  qualityScore: z.number(),
  updatedAt: z.string(),
  accent: z.enum(['violet', 'cyan', 'amber', 'rose']),
  capabilityParameters: capabilityParametersSchema.optional(),
  capabilityPresentations: capabilityPresentationsSchema.optional(),
})
